export default __webpack_public_path__ + "static/media/notification.e07763a4.svg";